import { Card, Filter, Pagination, Table, ViewHeader, useGet } from '@enkla-gui'
import React from 'react'
import { filters, icons } from '@config'

export default function Entities() {
  const { data: types } = useGet({ endpoint: 'api/entity/types' })
  const { data: companies } = useGet({ endpoint: 'api/company' })
  const { data: entities, setSorting, setPage, sorting, setFilter } = useGet({ endpoint: `api/entity` })

  return (
    <>
      <ViewHeader
        icon={icons.entity}
        title='Objekt'
        buttons={[{ icon: icons.create, title: 'Skapa objekt', href: '#!/entity/create' }]}
        subtitle='Översikt' />
      <Filter filters={[
        ...filters.entity,
        {
          type: 'select',
          label: 'Företag',
          key: 'company',
          values: companies?.data?.map(c => ({
            value: c.id,
            label: c.name
          })) || []
        },
        {
          type: 'toggle',
          label: 'Objektstyp',
          key: 'type',
          values: types?.map(c => ({
            value: c.id,
            label: c.name,
            icon: c.icon
          })) || []
        },
      ]} useFilter={_filter => setFilter({ ..._filter })} />
      <Card>
        <Table
          loadercount={15}
          rows={entities?.data}
          link={`/#!/entity/@{id}`}
          sorting={sorting}
          useSorting={sort => setSorting({ ...sort })}
          empty={{
            text:
              'Inga objekt att visa',
            icon: 'fa-layer-group'
          }}
          functions={{
            getType: type => (
              <div class='icon-badge'>
                <i class={`fas fa-fw ${type.icon}`} /> <span>{type.name}</span>{' '}
              </div>
            ),
            getStatus: entity => {
              if (!entity.type.rentable) return ''
              if (entity.rented) return <span class='w-100 badge bg-success'>Uthyrd</span>
              if (entity.upcoming) return <span class='w-100 badge bg-warning'>Kommande</span>
              return <span class='w-100 badge bg-default'>Vakant</span>
            },
            getParent: entity => {
              if (entity.parent) {
                return (
                  <a onClick={e => e.stopPropagation()} href={`/#!/entity/${entity.parent.id}`}>
                    {entity.parent.name}
                  </a>
                )
              }
              if (entity.company) {
                return (
                  <a onClick={e => e.stopPropagation()} href={`/#!/company/${entity.company.id}`}>
                    {entity.company.name}
                  </a>
                )
              }
              return ''
            }
          }}
          keys={['name', 'type>function:getType', '_this>function:getParent', '_this>function:getStatus', 'created_at>date:short']}
          headers={[
            {
              key: 'name',
              value: 'Namn',
              sortable: true,
              class: 'min'
            },
            {
              key: 'entity_type_id',
              value: 'Typ',
              sortable: true,
              class: 'min'
            },
            {
              value: 'Kopplat till'
            },
            {
              value: 'Status',
              class: 'min'
            },
            {
              key: 'created_at',
              value: 'Skapad',
              sortable: true,
              class: 'min'
            }
          ]}
        />
        <Pagination data={entities} fetch={setPage} pushToHistory />
      </Card>
    </>
  )
}
